export const ACADEMY_ENDPOINT = `https://${process.env.NEXT_PUBLIC_ACADEMY_GATEWAY_DOMAIN_NAME}`;
